module.exports = __webpack_public_path__ + "static/img/logo.7d198fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/logo.jpg
// module id = Tg4+
// module chunks = 1